import { sha256 } from "js-sha256";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import {
  AppContext,
  LOG_IN_FAILURE,
  LOG_IN_SUCCESS,
  LOG_OUT_SUCCESS,
  MENU_SET_ALL,
  SET_APP_ALL,
  SET_USER_HEALTH,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";
import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";
import {
  PostApi101,
  PostApi109,
  PostApi1902,
  PostApi1910,
  PostApi1913,
  PostApi1930,
  PostApi1931,
  PostApiGetNewPoint,
  PostApiLoginLog,
} from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";
import {
  getCookie,
  getCookieWs,
  lastLoginInfo,
  setCookie,
  setCookieWs,
} from "../../modules/utils/cookie";
import AuthAgreement from "../Company/TermsDetail/AuthAgreement";
import TermsPopup from "../Company/TermsDetail/TermsPopup";
import TermsViewer from "../Company/TermsDetail/TermsViewer";
import {
  AlertPopup,
  ContainerNew,
  InputPopup,
  SubMenu,
  openAlertPopup,
  openLayerFn,
} from "../Layout";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { SET_MENU_NEW_REPORT_LIST } from "./../../components/AppProvider";
import useTitle from "../../modules/hooks/useTitle";

let URL = [
  "/",
  "/SM",
  "/sm/bp/input",
  "/sm/bs/input",
  "/eocs",
  "/surround",
  "/pmr",
  "/proof/apply",
];

export default props => {
  const { cfg, auth, dispatch, phonecfg, userinfo } = useContext(AppContext);
  useTitle("로그인_아이디");
  const [inputIdStatus, setInputIdStatus] = useState("I");
  const [inputPwStatus, setInputPwStatus] = useState("I");

  const [loginSuccess, setLoginSuccess] = useState(false);
  const [isAutoLogin, setIsAutoLogin] = useState(true);
  const [dupList, setDupList] = useState("");
  const [attctNo, setAttctNo] = useState("");
  const [joinInfo, setJoinInfo] = useState({});

  const [inputs, setInputs] = useState({
    email: "",
    password: "",
    retUrl: props.match.params.retUrl,
  });

  const { retUrl } = inputs;

  const handleLogin = () => {
    // handleChange();
    if ($("input[name='id']").val().trim().length === 0) {
      // handleAlert('확인', '전화번호 또는 이메일을 입력해 주세요.');
      handleAlert("확인", "아이디를 입력해 주세요.");
    } else if ($("input[name='password']").val().trim().length === 0) {
      handleAlert("확인", "비밀번호를 입력해 주세요.");
    } else {
      handleRequest101();
    }
  };

  const requestGetNewPoint = userinfo => {
    PostApiGetNewPoint(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "E000") {
          dispatch({ type: SET_MENU_NEW_REPORT_LIST, data: res.result });
        } else {
          console.log("Interface Fail");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleRequest101 = () => {
    // 1차 입력한 그대로
    // 2차 trim
    const newPassword = sha256(
      $("input[name='id']").val().trim() +
        "eocs" +
        $("input[name='password']").val()
    );

    PostApi101(
      phonecfg,
      cfg,
      $("input[name='id']").val().trim(),
      newPassword,
      "",
      "000"
    )
      .then(res => {
        if (res.resultCode === "000") {
          setLoginSuccess(true);
          handleLoginSuccess(res);
          requestGetNewPoint(res);
          setCookie("lastLoginChannel", "000", 365);
          loginLogInterface(res.result[0], phonecfg, cfg, "I", "M", "000");
        } else {
          reHandleRequest101();
        }
        socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
          login: "in",
          userToken: res.result[0].userToken.toString(),
        });
      })
      .catch(err => {
        setLoginSuccess(false);
        // handleLoginFail();
      });
  };

  const reHandleRequest101 = () => {
    const newPassword = sha256(
      $("input[name='id']").val() +
        " " +
        "eocs" +
        $("input[name='password']").val()
    );

    PostApi101(
      phonecfg,
      cfg,
      $("input[name='id']").val() + " ",
      newPassword,
      "",
      "000"
    )
      .then(res => {
        if (res.resultCode === "000") {
          setLoginSuccess(true);
          handleLoginSuccess(res);
          requestGetNewPoint(res);
          setCookie("lastLoginChannel", "000", 365);
          loginLogInterface(res.result[0], phonecfg, cfg, "I", "M", "000");
        } else {
          setLoginSuccess(false);
          handleLoginFail();
        }
      })
      .catch(err => {
        setLoginSuccess(false);
        // handleLoginFail();
      });
  };

  const setUserHlthInfo = userinfo => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1910 = (userinfo, cardType) => {
    PostApi1910(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          if (data.length > 0)
            dispatch({
              type: MENU_SET_ALL,
              menutype: cardType,
              data: data,
            });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          dispatch({ type: SET_APP_ALL, data: data });
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleLoginFail = () => {
    dispatch({ type: LOG_IN_FAILURE });
    handleAlert(
      "확인",
      "아이디 또는 비밀번호가 틀립니다.<br />아이디와 비밀번호를 확인해 주세요"
    );
    $("input[name='password']").val("");
  };

  const handleLoginSuccess = res => {
    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.result[0],
      isAutoLogin: isAutoLogin,
    });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "in",
      userToken: res.result[0].userToken.toString(),
    });
    request1910(res.result[0], "");
    request1913(res.result[0]);
    setUserHlthInfo(res.result[0]);

    setCookieWs({
      isAutoLogin: isAutoLogin,
      signUpChannel: "000",
      loginInfo: res.result[0],
    });

    if (
      phonecfg.phoneOS === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) > 13
    ) {
      NativeAction(phonecfg, "login", "in");
    }

    // 전체 가져오기 수정 필요
    // if (res.result[0].isAuthOk == "0") {
    // 향후 수정 필요 임시임(DSRYU) 메세지 매번 보여줄 필요 없음 처리
    $("#exchangeTargetLogin").attr("id", "welcomeLogin");
    handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);
    // 로그인 처리는 여기에++++++
    // } else {
    // 로그인 이후 본인인증 여부에 따라
    //   $("#exchangeTargetLogin").attr("id", "welcomeLogin");
    //   _O.OpenMenu("/membership/certification");
    // }
  };

  const handleLoginSuccess500 = res => {
    // dispatch({ type: LOG_IN_SUCCESS, data: res.resultList[0], isAutoLogin: isAutoLogin});
    dispatch({
      type: LOG_IN_SUCCESS,
      data: res.loginInfo[0],
      isAutoLogin: isAutoLogin,
    });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "in",
      userToken: res.loginInfo[0].userToken.toString(),
    });
    request1910(res.loginInfo[0], "");
    request1913(res.loginInfo[0]);
    setUserHlthInfo(res.loginInfo[0]);
    $("#exchangeTargetLogin").attr("id", "welcomeLogin");
    handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);

    if (
      phonecfg.phoneOS === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) > 13
    ) {
      NativeAction(phonecfg, "login", "in");
    }

    loginLogInterface(res.resultList[0], phonecfg, cfg, "I", "M", "500");
    setCookieWs({
      isAutoLogin: isAutoLogin,
      signUpChannel: "500",
      userEmail: res.loginInfo[0].userId,
    });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleConfirmConfirmCB = () => {
    if (auth) {
      // 로그아웃 후 메인화면 이동
      dispatch({ type: LOG_OUT_SUCCESS });
      socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
        login: "out",
        userToken: "",
      });
      let idx = !retUrl ? 0 : parseInt(retUrl);
      if (idx != 9) {
        _O.Open(URL[idx]);
      } else {
        _O.Open("/");
      }
    }
  };
  const handleConfirmCancelCB = () => {
    _O.OpenMenu("/");
  };

  const handleAlertCB = () => {
    if (loginSuccess) {
      // 메인화면 이동
      let idx = !retUrl ? 0 : parseInt(retUrl);

      if (idx != 9) {
        _O.Open(URL[idx]);
      } else {
        _O.Open("/");
      }
    }
  };

  const settingAutoLogin = () => {
    setIsAutoLogin($("#setAutoLogin").is(":checked"));
  };

  const appleLoginAf = (userEmail, userName, UID, signUpChannel) => {
    // setCookieWs({'isAutoLogin': isAutoLogin, 'signUpChannel':'600'});
    if (userEmail && userEmail != null) {
      _O.Open(
        "/membership/snsLogin/" +
          userEmail +
          "/" +
          userName +
          "/" +
          UID +
          "/" +
          signUpChannel
      );
    } else {
      _O.Open("/membership/appleLogin/" + UID + "/" + signUpChannel);
    }
  };

  const goSnsLogin = param => {
    // setCookie("isAutologin", isAutoLogin, 365);

    if (param === "KAKAO") {
      setCookie("signUpChannel", "400", 1);
      setCookieWs({ isAutoLogin: isAutoLogin, signUpChannel: "400" });
      window.location.href = "ep://login/kakao";
    }

    if (param === "NAVER") {
      setCookie("signUpChannel", "100", 1);
      setCookieWs({ isAutoLogin: isAutoLogin, signUpChannel: "100" });
      window.location.href = "ep://login/naver";
    }

    if (param === "APPLE") {
      setCookie("signUpChannel", "600", 1);
      socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
    }
  };

  const noSpaceInput = () => {
    const str_space = /\s/;

    if (str_space.exec($("input[name='email']").val())) {
      $("input[name='email']").val(
        $("input[name='email']").val().replace(" ", "")
      );
    }
  };

  useEffect(() => {
    // openWebSocket();
    if (retUrl) console.log("로그인 화면 들어옴 : [", retUrl, "]");
    const autologin = getCookie("isAutologin");
    $("#setAutoLogin").prop("checked", autologin === "false" ? false : true);

    if (props.match.params.userId) {
      if (props.match.params.userId === "LOGOUT") {
        openLayerFn($(".alert-layer-logout"));
      } else {
        // $("input[name='id']").val(props.match.params.userId);
      }
    } else {
      // $("input[name='email']").val(getCookie("userEmail"));
      if (getCookie("lastLoginChannel")) {
        if (getCookie("lastLoginChannel").toString() === "000") {
          if (getCookie("userId")) {
            $("input[name='id']").val(getCookie("userId"));
          } else {
            $("input[name='id']").val(getCookie("userEmail"));
          }
        }
      }

      getCookieWs(lastLoginInfo);
    }

    // 폰토큰 없는경우
    if (
      !getCookie("phoneToken") ||
      getCookie("phoneToken") === "123" ||
      getCookie("phoneToken") === "undefined"
    ) {
      if (phonecfg.phoneOS == "IOS") {
        // socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
        socketManager(SocketCommand.GET_PHONE_INFO, undefined);
        // socketManager(SocketCommand.GET_GPS_INFO, undefined);
      } else {
        // 임시방편
        socketManager(SocketCommand.GET_PHONE_INFO_OLD, undefined);
        // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
      }
    }
  }, [props.match.params.userId]);

  const goRegist = signUpChannel => {
    setCookie("signUpChannel", signUpChannel, 1);
    _O.Open("/membership/userPhoneCheck");
    // if (signUpChannel === "000") {
    //   openLayerFn($("#termsPopup"));
    // } else {
    //   openLayerFn($("#inputPopup"));
    //   // userHabit(phonecfg, 'LI104');
    // }
  };

  const registToAttctNo = attctNoParam => {
    let attctNoVal = "";

    if (attctNoParam) {
      attctNoVal = attctNoParam;
    } else {
      attctNoVal = attctNo;
    }

    if (attctNoParam != 0) {
      PostApi1930(userinfo, cfg, phonecfg, "N", attctNoVal)
        .then(res => {
          if (res.resultCode === "000") {
            setJoinInfo(res.joinInfo);
            closeLayerFn($("#inputPopup"));
            openLayerFn($("#termsPopup"));
            attctNoVal = "";
          } else if (res.resultCode === "003") {
            setDupList(res.loginInfo);
            openLayerFn($("#existLayer"));
          } else if (res.resultCode === "004") {
            setLoginSuccess(true);
            handleLoginSuccess500(res);

            setTimeout(() => {
              socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
                login: "in",
                userToken: res.resultList[0].userToken.toString(),
              });
            }, 2000);
          } else {
            openAlertPopup("인증번호를 확인하세요.");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      PostApi1931(userinfo, cfg, phonecfg, attctNoVal, joinInfo)
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            // alert("연동에 성공하였습니다.");
            // handleConfirm("", "연동에 성공하였습니다.")

            if (res.resultCode === "000") {
              setLoginSuccess(true);
              handleLoginSuccess500(res);

              setTimeout(() => {
                socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
                  login: "in",
                  userToken: res.loginInfo[0].userToken.toString(),
                });
              }, 2000);
            } else {
              handleConfirm("", "로그인 실패");
            }
          } else {
            openAlertPopup("인증번호 등록에 실패하였습니다.");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // let findPwUrl = $("input[name=id]").val() != ""
  //   ? "/membership/inputUserInfo/findPw/" + $("input[name=id]").val()
  //   : "/membership/inputUserInfo/findPw"

  const findPwUrl = () => {
    if ($("input[name=id]").val() != "") {
      return "/membership/inputUserInfo/findPw/" + $("input[name=id]").val();
    } else {
      ("/membership/inputUserInfo/findPw");
    }
  };

  return (
    <Fragment>
      <ContainerNew
        Title={"로그인"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        isMain={true}>
        <Contents>
          <LoginComponentArea>
            <FlexDiv>
              <SubTitle>로그인</SubTitle>
              <BtnRegist onClick={e => goRegist("000")}>회원가입</BtnRegist>
            </FlexDiv>
            <p style={{ textAlign: "left", padding: "10px 0px" }}>
              {props.match.params.userId ? (
                <div>
                  선택하신 아이디는
                  <font style={{ fontWeight: "700", margin: "0px 4px" }}>
                    {props.match.params.userId}
                  </font>
                  입니다.
                </div>
              ) : (
                "생성하신 아이디와 비밀번호로 로그인하세요"
              )}
            </p>

            {/* INPUT FORM */}
            <div>
              <DivTitle>아이디</DivTitle>
              <InputDiv
                type="text"
                name="id"
                placeholder="아이디"
                focusEvent={setInputIdStatus}
                blurEvent={setInputIdStatus}
                inputState={inputIdStatus}
                maxLength={50}
              />

              <DivTitle>비밀번호</DivTitle>
              <InputDiv
                type="password"
                name="password"
                placeholder="비밀번호"
                focusEvent={setInputPwStatus}
                blurEvent={setInputPwStatus}
                inputState={inputPwStatus}
                maxLength={16}
              />

              {/* 로그인 버튼 */}
              <div>
                <div onClick={() => handleLogin()}>
                  <BtnLogin />
                </div>
                <FlexDiv
                  style={{
                    marginTop: "8px",
                    borderBottom: "1px solid #e0e0e0",
                  }}>
                  <div
                    onClick={() => _O.Open("/membership/inputUserInfo/find")}
                    style={{ textAlign: "left", textDecoration: "underline" }}>
                    아이디 찾기
                  </div>
                  <div style={{ margin: "0px 4px" }}>/</div>
                  <div
                    onClick={() =>
                      _O.Open(
                        $("input[name=id]").val() != ""
                          ? "/membership/inputUserInfo/findPw/" +
                              $("input[name=id]").val()
                          : "/membership/inputUserInfo/findPw"
                      )
                    }
                    style={{ textAlign: "left", textDecoration: "underline" }}>
                    비밀번호 찾기
                  </div>
                  <label
                    className="check-box"
                    style={{ display: "flex", marginLeft: "auto" }}>
                    <div>
                      <input
                        type="checkBox"
                        id="setAutoLogin"
                        style={{
                          verticalAlign: "-1px",
                          marginRGight: "8px",
                        }}
                        onClick={settingAutoLogin}
                      />
                      <i />
                      로그인 유지
                    </div>
                  </label>
                </FlexDiv>
              </div>
              {/* 로그인 버튼 */}
            </div>
            {/* INPUT FORM */}
          </LoginComponentArea>
        </Contents>
      </ContainerNew>
      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleConfirmCancelCB}
        handleConfirmCB={handleConfirmConfirmCB}
      />

      <TermsPopup />
      <AuthAgreement registToAttctNo={registToAttctNo} />
      <AlertPopup />
      <TermsViewer />

      <ExistIdLayer dupList={dupList} type="REG" />
      <InputPopup
        handleConfirm={handleConfirm}
        registToAttctNo={registToAttctNo}
        setAttctNo={setAttctNo}
      />
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};
const LoginComponentArea = ({ children }) => {
  return (
    <div>
      <div
        style={{
          textAlign: "center",
        }}
      >
        {children}
      </div>
    </div>
  );
};

const SnsLoginComponentArea = ({ children }) => {
  return (
    <div>
      <div
        style={{
          textAlign: "center",
          padding: "12px 20px",
        }}
      >
        {children}
      </div>
    </div>
  );
};

const InputState = (props) => {
  const { status } = props;

  const inputStatus = (key, text) => {
    switch (key) {
      case "I": {
        return "Inactive";
      }
      case "A": {
        return "Actived";
      }
      case "F": {
        return "Focused";
      }
      case "H": {
        return "Hover";
      }
      case "E": {
        return "Error" + text;
      }
      case "D": {
        return "Disabled";
      }
    }
  };

  return (
    <div
      style={{
        padding: "4px 0px 10px 12px",
        textAlign: "left",
      }}
    >
      <p>{inputStatus(status)}</p>
      {/* <p>Inactive</p> */}
    </div>
  );
};

const BtnLogin = (props) => {
  return <BtnLoginStyle>로그인</BtnLoginStyle>;
};

const DivComment = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        background: "#fff",
        marginLeft: "15px",
        marginTop: "-8px",
      }}
    >
      이름| 한글로 입력하세요
    </div>
  );
};

export const InputDiv = (props) => {
  const { type, name, defaultValue, focusEvent, blurEvent, inputState, placeholder, maxLength } =
    props;
  return (
    <div>
      <InputDataForm>
        <InputInvisible
          type={type}
          name={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onFocus={() => focusEvent("A")}
          onBlur={() => blurEvent("I")}
          maxLength={maxLength}
        />
      </InputDataForm>
      {/* <InputState status={inputState} /> */}
    </div>
  );
};

export const InputDivWithComment = (props) => {
  const { type, focusEvent, blurEvent, inputState, placeholder } = props;
  return (
    <div>
      <DivComment />
      <InputDataForm>
        <InputInvisible
          type={type}
          placeholder={placeholder}
          onFocus={() => focusEvent("A")}
          onBlur={() => blurEvent("I")}
        />
      </InputDataForm>
      <InputState status={inputState} />
    </div>
  );
};

const RoundDiv = styled.div`
  border: 1px solid ${(props) => props.color};
  color: ${(props) => props.color};
  border-radius: 20px;
  margin-left: auto;
  width: 30%;
  line-height: 26px;
`;

const BtnRegist = styled.div`
  // border: 1px solid black;
  border: 1px solid #7715ff;
  border-radius: 7px;
  color: #7715ff;
  margin-left: auto;
  line-height: 31.5px;
  padding: 0px 10px;
  font-weight: 500;
`;

const RoundDivCenter = styled.div`
  display: inline-block;
  border: 1px solid ${(props) => props.color};
  color: ${(props) => props.color};
  border-radius: 20px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  line-height: ${(props) => props.height};
`;

const FlexDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const SubTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
`;

const InputDataForm = styled.div`
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  padding: 0px 15px;
  height: 48px;
  margin-bottom: 10px;
`;

const InputInvisible = styled.input`
  border: 0px;
  width: 100%;
  height: 100%;
`;

const BtnLoginStyle = styled.div`
  height: 48px;
  border-radius: 8px;
  background: #000;
  color: #fff;
  line-height: 48px;
  font-size: 18px;
`;

// logType : I(로그인) O(로그아웃)
// procType : A(자동) M(수동)
// scrptTypeCd : signUpChannel
export const loginLogInterface = (userinfo, phonecfg, cfg, logType, procType, scrptTypeCd) => {
  if (logType === "I") {
    PostApiLoginLog(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  } else {
    PostApi109(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  }
};

const DivTitle = styled.div`
  padding-left: 7px;
  text-align: left;
`;
